import addMinutes from 'date-fns/addMinutes';

/**
 * @deprecated This helper is deprecated. Use the @dealroadshow/uikit-date-time class with appropriate methods instead.
 */
const getLocalDate = (date: Date = new Date()): Date => addMinutes(date, -date.getTimezoneOffset());

export default getLocalDate;
